import React from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';

import useStyle from './ActivityAtEduModal.style';
import { IActivityAtEduModal } from './ActivityAtEduModal.interface';

const style = {
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  // width: 400,
  // maxWidth: 400,
  maxHeight: 600,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  overflow: 'auto',
};

/**
 * this component renders a modal that is used in the [[ActivityAtEduBox]] component.
 * @component
 */
const ActivityAtEduModal = (props: IActivityAtEduModal) => {
  const classes = useStyle();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Box onClick={handleOpen} className={classes.iconContainer}>
        {props.icon}
      </Box>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} style={{ position: 'absolute', maxHeight: '70vh' }}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {props.title}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {props.description}
          </Typography>

          <Box sx={{ margin: '1rem' }}>{props.children}</Box>

          <Stack direction="row" spacing={2}>
            <Button variant="outlined" onClick={handleClose}>
              Cerrar
            </Button>
          </Stack>
        </Box>
      </Modal>
    </div>
  );
};

export default ActivityAtEduModal;
